/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Footer_Operator_LabelInputs */

const tr_legal_footer_operator_label = /** @type {(inputs: Legal_Footer_Operator_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İşleten:`)
};

const en_legal_footer_operator_label = /** @type {(inputs: Legal_Footer_Operator_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operated by:`)
};

const de_legal_footer_operator_label = /** @type {(inputs: Legal_Footer_Operator_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betreiber:`)
};

const ru_legal_footer_operator_label = /** @type {(inputs: Legal_Footer_Operator_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оператор:`)
};

/**
* | output |
* | --- |
* | "Operated by:" |
*
* @param {Legal_Footer_Operator_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const legal_footer_operator_label = /** @type {((inputs?: Legal_Footer_Operator_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Footer_Operator_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_footer_operator_label(inputs)
	if (locale === "de") return de_legal_footer_operator_label(inputs)
	if (locale === "ru") return ru_legal_footer_operator_label(inputs)
	return tr_legal_footer_operator_label(inputs)
});